import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Table from 'react-bootstrap/Table';
import { getAllUsers } from '../actions/userActions';
import Loader from '../components/Loader'
import Message from '../components/Message'
import '../index.css'
import { getAllComments } from '../actions/commentsActions';

function AdminScreen() {

    const dispatch = useDispatch()
    const history = useNavigate()

    const usersState = useSelector(state => state.users)
    const commentsState = useSelector(state => state.comments)

    const { error, loading, users } = usersState
    const { commentError, commentLoading, comments } = commentsState

    const userLogin = useSelector(state => state.userLogin)
    const { userInfo} = userLogin

    useEffect(() => {
        if (!userInfo) {
            history('/login', { replace: true})
        } else if (!userInfo.isAdmin) {
            history('/', { replace: true})
        }

        dispatch(getAllUsers())
        dispatch(getAllComments())
    }, [dispatch])

    return (
        <div>
            <h2>
            Registered Users
            </h2>
            {loading ? <Loader/>
            : error ? <Message variant='error'>{error}</Message>
            : users ?
            <div>
              <Table striped bordered hover size='sm'>
                  <thead bgcolor='grey'>
                      <tr>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Email</th>
                          <th>Registered</th>
                      </tr>
                    </thead>
                    {users.map(user => (
                        <tbody>
                            <th>{user.firstName}</th>
                            <th>{user.lastName}</th>
                            <th>{user.email}</th>
                            <th>{new Date(user.createdDate).toDateString()}</th>
                        </tbody>
                    ))}
                  </Table>
              </div>
              : ''}

              <h2>Comments</h2>
              {commentLoading ? <Loader/>
              : commentError ? <Message variant='commentError'>{error}</Message>
              : comments ?
              <div>
                <Table striped bordered hover size='sm'>
                    <thead>
                        <tr>
                            <th>Comment</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Submitted</th>
                        </tr>
                    </thead>
                    {comments.map(comment => (
                          <tbody>
                              <th>{comment.comment}</th>
                              <th>{comment.firstName}</th>
                              <th>{comment.lastName}</th>
                              <th>{new Date(comment.createdDate).toDateString()}</th>
                          </tbody>
                      ))}
                    </Table>
                </div>
                : ''
            }
      </div>
    )
}

export default AdminScreen